import React from 'react';
import PackageCard from './PackageCard';

const PackageList = ({ packages }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 justify-center">
    {packages.map(pkg => (
      <div key={pkg.title}>
        <PackageCard pkg={pkg} />
      </div>
    ))}
  </div>
);

export default PackageList;
